import { Layout } from 'app/layout/layout.types';
import * as brand from '../../../../brand-themes';

// Types
export type Scheme = 'auto' | 'dark' | 'light';
export type Screens = { [key: string]: string };
export type Theme = 'theme-default' | string;
export type Themes = { id: string; name: string }[];

/**
 * AppConfig interface. Update this interface to strictly type your config
 * object.
 */
export interface AppConfig {
    layout: Layout;
    scheme: Scheme;
    screens: Screens;
    theme: Theme;
    themes: Themes;
}

/**
 * Default configuration for the entire application. This object is used by
 * FuseConfigService to set the default configuration.
 *
 * If you need to store global configuration for your app, you can use this
 * object to set the defaults. To access, update and reset the config, use
 * FuseConfigService and its methods.
 *
 * "Screens" are carried over to the BreakpointObserver for accessing them within
 * components, and they are required.
 *
 * "Themes" are required for Tailwind to generate themes.
 */
export const appConfig: AppConfig = {
    layout: 'classic',
    scheme: 'light',
    screens: {
        sm: '600px',
        md: '960px',
        lg: '1280px',
        xl: '1440px'
    },
    theme: 'theme-default',
    themes: [
        {
            id: 'theme-default',
            name: 'Default'
        },
        {
            "id": "theme-alpha",
            "name": "alpha"
        },
        {
            "id": "theme-cbredemo",
            "name": "cbredemo"
        },
        {
            "id": "theme-amey",
            "name": "amey"
        },
        {
            "id": "theme-brutonknowles",
            "name": "brutonknowles"
        },
        {
            "id": "theme-bulleys",
            "name": "bulleys"
        },
        {
            "id": "theme-cityscape",
            "name": "cityscape"
        },
        {
            "id": "theme-langtree",
            "name": "langtree"
        },
        {
            "id": "theme-masonowen",
            "name": "masonowen"
        },
        {
            "id": "theme-metrolife",
            "name": "metrolife"
        },
        {
            "id": "theme-mojo",
            "name": "mojo"
        },
        {
            "id": "theme-rapleys",
            "name": "rapleys"
        },
        {
            "id": "theme-rem",
            "name": "rem"
        },
        {
            "id": "theme-rogerhannah",
            "name": "rogerhannah"
        },
        {
            "id": "theme-rogroup",
            "name": "rogroup"
        },
        {
            "id": "theme-speirs",
            "name": "speirs"
        },
        {
            "id": "theme-stepnell",
            "name": "stepnell"
        },
        {
            "id": "theme-tpm",
            "name": "tpm"
        },
        {
            "id": "theme-workman",
            "name": "workman"
        },
        {
            "id": "theme-adpt",
            "name": "adpt"
        },
        {
          "id": "theme-lisney",
          "name": "lisney"
        },
        {
          "id": "theme-fishergerman",
          "name": "fishergerman"
        },
        {
          "id": "theme-grahamsibbald",
          "name": "grahamsibbald"
        },
        {
          "id": "theme-caxtons",
          "name": "caxtons"
        }
        ,
        {
          "id": "theme-magenta",
          "name": "magenta"
        }
        ,
        {
          "id": "theme-cyan",
          "name": "cyan"
        },
        {
          "id": "theme-helix",
          "name": "helix"
        },
        {
          "id": "theme-ashdownphillips",
          "name": "ashdownphillips"
        },
      {
        "id": "theme-cobbs",
        "name": "cobbs"
      },
      {
        "id": "theme-carterjonas",
        "name": "carterjonas"
      },
      {
        "id": "theme-breckon",
        "name": "breckon"
      }
    ]

};
